<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_23107_32198)">
<path d="M10.5 6.18457V8.18457H5.5V19.1846H16.5V14.1846H18.5V20.1846C18.5 20.4498 18.3946 20.7041 18.2071 20.8917C18.0196 21.0792 17.7652 21.1846 17.5 21.1846H4.5C4.23478 21.1846 3.98043 21.0792 3.79289 20.8917C3.60536 20.7041 3.5 20.4498 3.5 20.1846V7.18457C3.5 6.91935 3.60536 6.665 3.79289 6.47746C3.98043 6.28993 4.23478 6.18457 4.5 6.18457H10.5ZM21.5 3.18457V12.1846L17.706 8.39157L11.707 14.3916L10.293 12.9776L16.292 6.97757L12.5 3.18457H21.5Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_23107_32198">
<rect width="24" height="24" fill="white" transform="translate(0.5 0.18457)"/>
</clipPath>
</defs>
</svg>
